import { createSelector } from 'reselect';
import { NAME } from './constants';

export const getModel = state => state[NAME];

/** activeElement **/
export const getActiveElementModel = createSelector(
    getModel,
    (model) => model.activeElement
);

/** activeElement **/
export const getActiveElement = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.data
);
export const getIsFetchingElement = createSelector(
    getActiveElementModel,
    (activeElement) => activeElement.isFetching
);

/** form **/
export const getForm = createSelector(
    getModel,
    (model) => model.form
);
export const getFormValues = createSelector(
    getForm,
    (form) => form.formValues
);
export const getIsSavingForm = createSelector(
    getForm,
    (form) => form.isSaving
);
export const getFormErrors = createSelector(
    getForm,
    (form) => form.formErrors
);
export const getFormErrorsMessages = createSelector(
    getForm,
    (form) => form.formErrorMessages
);

/** elements **/
export const getElements = createSelector(
    getModel,
    (model) => model.elements.data
);
export const getProcessedElements = createSelector(
    getModel,
    (model) => model.elements.processedElements
);
export const getIsFetchingElements = createSelector(
    getModel,
    (model) => model.elements.isFetching
);
export const getFetching = createSelector(
    getModel,
    (model) => model.elements.fetching
);

/** delete **/
export const getIsDeleting = createSelector(
    getModel,
    (model) => model.delete.isDeleting
);
export const getIdForDelete = createSelector(
    getModel,
    (model) => model.delete.id
);

/** pagination **/
export const getSelectedPage = createSelector(
    getModel,
    (model) => model.pagination.selectedPage
);
export const getPagination = createSelector(
    getModel,
    (model) => model.pagination
);

/** sort **/
export const getSortColumn = createSelector(
    getModel,
    (model) => model.sort
);
export const getSortType = createSelector(
    getModel,
    (model) => model.sort
);

/** filter **/
export const getFilterFields = createSelector(
    getModel,
    (model) => model.filter
);

/** data **/
export const getData = createSelector(
    getModel,
    (model) => model.data
);

/** accept **/
export const getIsAccepting = createSelector(
    getModel,
    (model) => model.accept.isAccepting
);
export const getIdToAccept = createSelector(
    getModel,
    (model) => model.accept.id
);

/** receive **/
export const getIsReceiving = createSelector(
    getModel,
    (model) => model.receive.isReceiving
);
export const getIdToReceive = createSelector(
    getModel,
    (model) => model.receive.id
);
